'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Link } from '../link/link.js';

/**
 * ErrorSummary link component, used to link to a specific error. Used within an ErrorSummary.Item.
 *
 * @example
 * <ErrorSummary>
 *   <ErrorSummaryItem>
 *     <ErrorSummaryLink href='#'>Error 1</ErrorSummaryLink>
 *   </ErrorSummaryItem>
 * </ErrorSummary>
 */
const ErrorSummaryLink = forwardRef(function ErrorSummaryLink({ ...rest }, ref) {
    return jsx(Link, { ref: ref, "data-color": 'neutral', ...rest });
});

export { ErrorSummaryLink };
